import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { LOCALES } from '../libs/defines';

Vue.use(VueI18n);

const loadLocaleMessages = () => {
    const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
    const messages = {};

    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);

        if (matched && matched.length > 1)
            messages[matched[1]] = locales(key);
    });

    return messages;
};

export default new VueI18n({
    locale: navigator.language.startsWith(LOCALES.RU) ? LOCALES.RU : LOCALES.EN,
    fallbackLocale: LOCALES.RU,
    messages: loadLocaleMessages()
});